// import { dynamicEnvironment } from '@env';

import { environment } from '@env';

export function apiBaseUrl() {
  return environment.apiBaseUrl;
}
